export default "__VITE_ASSET__C0kFF2Bs__"